import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';

export interface TimeSelected {
    hours: number;
    minutes: number;
    seconds: number;
    format: 'AM' | 'PM';
}

@Component({
    selector: 'dian-time-select',
    standalone: true,
    imports: [DecimalPipe, CommonModule],
    templateUrl: './time-select.component.html',
    styleUrl: './time-select.component.scss'
})
export class TimeSelectComponent implements OnInit {
    @ViewChildren('optionsContainer', { read: ElementRef }) optionsContainer!: QueryList<ElementRef<HTMLDivElement>>;
    @Input() set value(value: Omit<TimeSelected, 'format'>) {
        const [hours, format] = this.convertTo12HourFormat(value?.hours ?? 0);
        this.timeValue.format = format;
        this.timeValue.hours = hours;
        this.timeValue.minutes = value?.minutes ?? 0;
        this.timeValue.seconds = value?.seconds ?? 0;
    }
    @Input() options: unknown[] = [];
    @Output() timeSelected = new EventEmitter<Omit<TimeSelected, 'format'>>;

    optionsType: 'string' | 'number' = 'number';
    timeValue:  TimeSelected = { seconds: 0, minutes: 0, hours: 1, format: 'AM' };


    openTimePanel = false;
    minValue = 0;
    hoursList: string[] = []
    minList: string[] = []
    secondList: string[] = []
    maxRangeValue = 59;

    hours = { options: this.hoursList, templateId: 'hours' }
    minutes = { options: this.minList, templateId: 'minutes' }
    seconds = { options: this.minList, templateId: 'seconds' }
    formatosDeHora = { options: ['AM', 'PM'], templateId: 'format' }

    ngOnInit(): void {
        if (!this.options.length) {
            this.setOptionsByRangeValues();
        }
    }

    toggleOptions(el: HTMLElement) {
        this.closeActiveOptions(el.id);
        el.classList.toggle('open');
    }

    setOptionSelected(el: HTMLInputElement, value: string, templateId: keyof TimeSelected) {
        el.value = value;
        el.classList.toggle('open')
        this.setTime(value, templateId)
    }

    validateInput($event: InputEvent, maxValue: number, templateId: keyof TimeSelected) {
        const el = $event.target as HTMLInputElement;
        const digits = el.value.replace(/\D/g, '');
        if (digits.length !== 0 && parseInt(digits) <= maxValue) {
            el.value = digits;
            this.setTime(el.value, templateId);
        } else {
            el.value = digits.split('').slice(0, digits.length - 1).join('')
        }
    }

    setTime(value: string, templateId: keyof TimeSelected) {
        if (templateId === this.formatosDeHora.templateId) {
            Object.assign(this.timeValue, { [templateId]: value });
        } else {
            Object.assign(this.timeValue, { [templateId]: parseInt(value) })
        }

        this.timeSelected.emit({
            hours: this.convertTo24Hour(this.timeValue.hours, this.timeValue.format),
            minutes: this.timeValue.minutes,
            seconds: this.timeValue.seconds
        });
    }

    convertTo24Hour(hour: number, format: 'AM' | 'PM') {
        if (format === 'AM') {
            return hour === 12 ? 0 : hour;
        } else {
            return hour === 12 ? 12 : hour + 12;
        }
    }

    convertTo12HourFormat(hour: number): [number, 'AM'|'PM'] {
        // Validar que la hora esté en el rango de 0 a 23
        if (hour < 0 || hour > 23) {
            throw new Error("La hora debe estar en el rango de 0 a 23.");
        }

        const period = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 === 0 ? 12 : hour % 12;

        return [hour12, period];
    }

    private closeActiveOptions(id: string) {
        this.optionsContainer.forEach((elementRef: ElementRef<HTMLDivElement>) => {
            if (elementRef.nativeElement.id !== id) {
                elementRef.nativeElement.classList.remove('open')
            }
        })
    }

    private setOptionsByRangeValues() {
        for (let index = 0; index <= this.maxRangeValue; index++) {
            if (index < 10) {
                this.hoursList.push(index < 9 ? `0${index + 1}` : `${index + 1}`);
                this.minList.push(`0${index}`);
            } else if (index >= 10 && index < 12) {
                this.minList.push(`${index}`);
                this.hoursList.push(`${index + 1}`);
            } else {
                this.minList.push(index.toString());
            }
        }
    }
}
